import CompanyBranchListViewComponent from "../components/CompanyBranchListView";
import useCompanyBranch from "../hooks/useCompanyBranch";

function CompanyBranchListView(props) {
  const useCompanyBranchProps = useCompanyBranch(props);
  return <CompanyBranchListViewComponent {...useCompanyBranchProps} />;
}

export default CompanyBranchListView;
